'use strict';

const sdkConfiguration = require('./configurations/sdk-configuration');
const Utilities = require('./requests/utilities');
const Customer = require('./requests/customer');
const Partner = require('./requests/partner');
const Billing = require('./requests/billing');
const Offers = require('./requests/offers');
const request = require('./helpers/logged-request');


class UserPartnerOperations {
  constructor(userCredentials) {
    this.customer = new Customer(userCredentials, request, sdkConfiguration);
    this.offers = new Offers(userCredentials, request, sdkConfiguration);
    this.utilities = new Utilities(userCredentials, request, sdkConfiguration);
    this.partner = new Partner(userCredentials, request, sdkConfiguration);
    this.billing = new Billing(userCredentials, request, sdkConfiguration);
  }

}

module.exports = UserPartnerOperations;
